import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Expedition 33 Any% Restricted" mdxType="SEO" />
    <h1 {...{
      "id": "clair-obscur-expedition-33-any-restricted"
    }}>{`Clair Obscur: Expedition 33 Any% Restricted`}</h1>
    <h3 {...{
      "id": "notation"
    }}>{`Notation`}</h3>
    <p>{`For menus, I will sometimes have something in parenthesis. If it's (S1-3), it refers to the slot the Picto should be placed in. If it's a Playstation controller button, it's a button you should press to optimize the menu.`}</p>
    <p>{`For battles, there will sometimes be something like (1.1 QTE). This refers to the Quick Time Action you do when you use an Ability. A perfect is 1.2, a normal is 1.1, and a fail is 1.0. The number refers to the damage multiplier the skill gets from the QTE.`}</p>
    <p>{`For loading saves, I will use notation like load S0 to load the top save, or S2 to load the 3rd save (2 down).`}<br parentName="p"></br>{`
`}{`These will assume no mistakes, since mistakes will often lead to extra saves. The notes will still describe which save to load.`}</p>
    <hr></hr>
    <p>{`You can check the changelog at the bottom of the notes.`}</p>
    <p>{`These are my personal notes for the category, the writing will reflect that. For the most part these notes will not say where to go or where things are, just what to do. I will be updating these as the route progresses, changes will be reflected in the changelog at the bottom of the notes.`}</p>
    <p>{`There will also be enemy data and maybe some other useful information at the bottom of the notes.`}</p>
    <p>{`If there's a time listed by a fight, it's my best time for it so far. It does not represent the average.`}</p>
    <h2 {...{
      "id": "prologue"
    }}>{`Prologue`}</h2>
    <p>{`Do Windmill skip. The notes will assume you do it, but will note small changes if you fight Maelle where applicable.`}<br parentName="p"></br>{`
`}{`If you're learning, don't bother with Windmill and just fight Maelle.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "maelle-450hp"
      }}>{`Maelle 450HP`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1XP, $50, Colour of Lumina`}</p>
      </blockquote>
      <p>{`Attack > Parry > 3 Shots (2 if 1 head), Attack > Parry`}</p>
    </Battle>
    <h3 {...{
      "id": "harbor"
    }}>{`Harbor`}</h3>
    <ul>
      <li parentName="ul">{`Talk to Maelle, skip Maelle duel`}</li>
      <li parentName="ul">{`Talk to Aprentices`}</li>
      <li parentName="ul">{`Talk to Emma`}</li>
    </ul>
    <p>{`4 CS on Transition`}</p>
    <h2 {...{
      "id": "act-i"
    }}>{`Act I`}</h2>
    <h3 {...{
      "id": "spring-meadows"
    }}>{`Spring Meadows`}</h3>
    <Menu timing="Cutscene entering Lancelier or Portier" mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +Lumiere Assault Left-Bottom`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lancelier-122hp-6xp-50-010"
      }}>{`Lancelier 122HP 6XP $50 (0:10)`}</h4>
      <ul>
        <li parentName="ul">{`Shoot twice, Attack > Parry`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "portier-450hp-008"
      }}>{`Portier 450HP (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`10XP, $75, Dodger + 0-2 Chroma Catalyst `}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spot + 1 shot, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
    </Battle>
    <p>{`Pick up `}<strong parentName="p">{`Critical Burn`}</strong>{`.`}</p>
    <p>{`Do House skip, pick up `}<strong parentName="p">{`$360`}</strong>{` and `}<strong parentName="p">{`Energy Tint`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you fought Maelle in Prologue, can skip the Chroma.`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "3-volester-81hp-017"
      }}>{`3 Volester 81HP (0:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`43XP, $216, 0-2 Chroma Catalyst?`}<br parentName="p"></br>{`
`}{`Parry timing is on slowdown/freeze frames on both of their attacks`}</p>
      </blockquote>
      <p>{`Parry both attacks. Shoot last one to death. Requires 5AP.`}</p>
    </Battle>
    <Menu timing="During journal cutscene" mdxType="Menu">
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <p>{`-+Gustave`}</p>
      <h5 {...{
        "id": "pictos"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Dead Energy II`}</strong>{`. Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` under the bridge.`}</p>
    <Menu timing="Flag before Eveque" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +6 Might (6)`}</li>
        <li parentName="ul">{`Lune: +6 Might (6)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Powerful`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Eveque battle" mdxType="Menu">
      <h5 {...{
        "id": "pictos-1"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +Dead Energy II`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "eveque-139"
      }}>{`Eveque (1:39)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$862, Cleansing Tint, 5 Chroma Catalyst, 0-2 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot off shields (last shield shoot weakpoint), Immolation`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Lumiere Assault`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Gustave / Ice Lance / Attack`}</li>
        <li parentName="ul">{`Gustav: Can shoot till 4AP, Overcharge`}</li>
      </ul>
      <p>{`If not dead, shoot off shields and damage as best as you can.`}</p>
    </Battle>
    <h3 {...{
      "id": "continent"
    }}>{`Continent`}</h3>
    <p>{`Go to Camp before entering Flying Waters`}</p>
    <h3 {...{
      "id": "flying-waters"
    }}>{`Flying Waters`}</h3>
    <p>{`Optionally, menu during cutscene and remove Gustave's pictos.`}</p>
    <p>{`Load most recent save after autosave after Demineurs. If you don't get one, make a picto save.`}</p>
    <p>{`Menu during the cutscene where you enter Maelle's room.`}</p>
    <Menu timing="Cutscene entering Flying Waters or Manor" mdxType="Menu">
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: -Lumiere Assault`}</li>
      </ul>
    </Menu>
    <Menu timing="Getting Maelle" mdxType="Menu">
      <h5 {...{
        "id": "skills-2"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: -Spark`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-2"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`After getting Maelle, reload the manor autosave (Top+1)`}<br parentName="p"></br>{`
`}{`After talking to door, open menu as screen is fading out and load most recent autosave.`}</p>
    <p>{`If no drop, pick up `}<strong parentName="p">{`Recoat`}</strong>{`.`}</p>
    <p>{`Talk to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-1"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +6 Might (12)`}</li>
        <li parentName="ul">{`Maelle: +15 Might (15)`}</li>
        <li parentName="ul">{`Lune: +2 Might (8), +4 Agility (4)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +Marking Shot`}</li>
        <li parentName="ul">{`Maelle: +Swift Stride`}</li>
        <li parentName="ul">{`Lune: +Rockslide`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Staggering Attack`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Do `}<strong parentName="p">{`Goblu Skip`}</strong></p>
    <h3 {...{
      "id": "camp"
    }}>{`Camp`}</h3>
    <Menu timing="Talk to Curator" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Maellum +1 (3)`}</li>
      </ul>
    </Menu>
    <Menu timing="Jump to campfire" mdxType="Menu">
      <h5 {...{
        "id": "pictos-3"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+Staggering Attack (Mash A)`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Reload the latest autosave, go to sleep.`}</p>
    <h3 {...{
      "id": "continent-1"
    }}>{`Continent`}</h3>
    <h3 {...{
      "id": "esquies-nest"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Password Skip`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "francois-035"
      }}>{`Francois (0:35)`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot 2 times (3 if Lune target), Immolation`}</li>
        <li parentName="ul">{`Gustave: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <p>{`Counter if Maelle target for crit safety.`}</p>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, counter until 800 counter damage.`}</p>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Gustave if 0AP, else skip`}</li>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Battle>
    <p>{`Menu during Esquie's cutscene.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills-3"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Rockslide Bottom-Left`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-4"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`After talking to Esquie cutscene, load autosave outside Flying Waters (Top + 1).`}<br parentName="p"></br>{`
`}{`Go to Flying Waters entrance, then reload most recent autosave and mash to enter Flying Waters.`}<br parentName="p"></br>{`
`}{`Then exit Flying Waters.`}</p>
    <h3 {...{
      "id": "continent-2"
    }}>{`Continent`}</h3>
    <p>{`Chroma Elixer to autosave at midpoint between SWC and ES1.`}<br parentName="p"></br>{`
`}{`Right before picking up `}<strong parentName="p">{`Energising Start I`}</strong>{`, reload most recent autosave and pick up `}<strong parentName="p">{`Energising Start I`}</strong>{` during the load.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$1305`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to SWC entrance and camp.`}</p>
    <h3 {...{
      "id": "camp-1"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-3"
    }}>{`Continent`}</h3>
    <h3 {...{
      "id": "stone-wave-cliffs"
    }}>{`Stone Wave Cliffs`}</h3>
    <p>{`Menu during first cutscene.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-5"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+(S2) Energising Start I`}</li>
            <li parentName="ul">{`+(S3) Critical Burn`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`$790`}</strong>{`.`}</p>
    <Menu timing="Delaram split point" mdxType="Menu">
      <h5 {...{
        "id": "pictos-6"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Unlock Paint Cage, reload autosave and pick up `}<strong parentName="p">{`Delaram`}</strong>{` during the load.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{`. Pick up `}<strong parentName="p">{`First Strike`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You can skip the Lumina if you fought Maelle in Prologue.`}</p>
    </blockquote>
    <Menu timing="Jump down from First Strike" mdxType="Menu">
      <h5 {...{
        "id": "pictos-7"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +(S1) First Strike`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`SOS Power`}</strong>{`.`}</p>
    <Menu timing="Jump to Polished at start of Farm" mdxType="Menu">
      <h5 {...{
        "id": "pictos-8"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+SOS Power`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Polished Chroma Catalyst`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Deunam`}</strong>{`.`}</p>
    <p>{`Do Cave skip and pick up `}<strong parentName="p">{`Coralim`}</strong>{`.`}</p>
    <Menu timing="Flag before Lampmaster" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-2"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +6 Might (18)`}</li>
        <li parentName="ul">{`Maelle: +3 Might (18)`}</li>
        <li parentName="ul">{`Lune: +6 Agility (10)`}</li>
      </ul>
    </Menu>
    <Menu timing="Lampmaster cutscene" mdxType="Menu">
      <h5 {...{
        "id": "weapons"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Delaram`}</li>
        <li parentName="ul">{`Maelle: Duenam`}</li>
        <li parentName="ul">{`Lune: Coralim`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`This fight is pretty dynamic, so practice is recommended here.`}</p>
      </blockquote>
      <h4 {...{
        "id": "lampmaster-227"
      }}>{`Lampmaster (2:27)`}</h4>
      <h5 {...{
        "id": "turn-0"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Gustave: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Rockslide`}</li>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee (finishes with good RNG)`}</li>
      </ul>
      <h4 {...{
        "id": "phase-2"
      }}>{`Phase 2`}</h4>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Gustave: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Offensive Switch`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Rockslide`}</li>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee (kills if lucky)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Rockslide`}</li>
        <li parentName="ul">{`Gustave: Overcharge`}</li>
      </ul>
    </Battle>
    <h2 {...{
      "id": "act-ii"
    }}>{`Act II`}</h2>
    <h3 {...{
      "id": "camp-2"
    }}>{`Camp`}</h3>
    <Menu timing="Camp flag" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-3"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +33 Might`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +Berserk Slash (Left-Middle)`}</li>
      </ul>
    </Menu>
    <Menu timing="Anytime before Chalier. Jump to Flag in camp" mdxType="Menu">
      <h5 {...{
        "id": "weapons-1"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Do Pictos from left menu`}</p>
      </blockquote>
      <h5 {...{
        "id": "pictos-9"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Augmented First Strike`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "continent-4"
    }}>{`Continent`}</h3>
    <h3 {...{
      "id": "forgotten-battlefield"
    }}>{`Forgotten Battlefield`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chalier"
      }}>{`Chalier`}</h4>
      <ul>
        <li parentName="ul">{`Parry 1st hit.`}</li>
        <li parentName="ul">{`Verso: Berserk Slash (kills with 1 crit or Verso target counter)`}</li>
      </ul>
    </Battle>
    <Menu timing="Any small jump" mdxType="Menu">
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <p>{`-Lune`}</p>
    </Menu>
    <p>{`Buy `}<strong parentName="p">{`Inverted Affinity`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Do launch out of `}<strong parentName="p">{`Forgotten Battlefield`}</strong>{`. For safety save, can use Chroma Elixer.`}</p>
    <h3 {...{
      "id": "camp-3"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-5"
    }}>{`Continent`}</h3>
    <h4 {...{
      "id": "monoco-station-skip"
    }}>{`Monoco Station Skip`}</h4>
    <p>{`Go to fight in front of you and preempt it. Then flee.`}</p>
    <p>{`Go to invisible bridge, Chroma Elixer by tree on hill on right side.`}<br parentName="p"></br>{`
`}{`Load S0, do Monoco Station skip.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Camp Dismount`}</strong><br parentName="p"></br>{`
`}{`Get to the position needed, enter Camp.`}<br parentName="p"></br>{`
`}{`Go to sleep. When you spawn on the Continent, game should make a new autosave.`}<br parentName="p"></br>{`
`}{`Load S0, then continue skip.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Using Camp for Esquie dismounts is slower RTA, but faster LRT.`}<br parentName="p"></br>{`
`}{`Since this category is timed LRT, notes will have the Camp version`}<br parentName="p"></br>{`
`}{`But if running RTA, you can do the classic SWC Dismount version.`}</p>
    </blockquote>
    <p>{`Climb up building, `}<strong parentName="p">{`Camp Dismount`}</strong>{`. Get into position by cliff for Esquie mount.`}</p>
    <Menu timing="By cliffside for Esquie mount." mdxType="Menu">
      <h5 {...{
        "id": "pictos-10"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity > Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Load the save outside `}<strong parentName="p">{`Stone Wave Cliffs`}</strong>{`. It will be ~15s after the save before it.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Hidden Gestral Arena`}</strong>{`. `}<strong parentName="p">{`Dismount Esquie`}</strong>{` a bit before the entrance, and walk to the entrance.`}<br parentName="p"></br>{`
`}{`Picto save, then quickly load `}<strong parentName="p">{`S2 - OL Skip Save`}</strong>{`. As save is loading, quickly open & close menu, and `}<strong parentName="p">{`mount Esquie`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`To mount Esquie in the Hidden Gestral Arena entrance, you have to use keyboard for the mount.`}<br parentName="p"></br>{`
`}{`I like to do Tab > Circle > Z. Controller doesn't work because interact & mount share the same button.`}</p>
    </blockquote>
    <p>{`Run up mountain, get onto building past railing. `}<strong parentName="p">{`Camp Dismount`}</strong>{`.`}</p>
    <p>{`Run off the building on the left side. Run on invisible ground to the left over the water, and climb onto mountain in front. Picto save, and load `}<strong parentName="p">{`S3 - Hidden Gestral Arena Save`}</strong></p>
    <p>{`Load `}<strong parentName="p">{`S0 - OL Skip Save`}</strong>{`, and enter `}<strong parentName="p">{`Hidden Gestral Arena`}</strong>{` while loading.`}</p>
    <h3 {...{
      "id": "hidden-gestral-arena"
    }}>{`Hidden Gestral Arena`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Keep an eye on your drops here, you can potentially get Coralim 13 with good catalyst drops`}</p>
    </blockquote>
    <Menu timing="Flag" mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-3"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +Defiant Strike (Left-Top)`}</li>
      </ul>
    </Menu>
    <p>{`All fights are Defiant Strikes + Counters.`}<br parentName="p"></br>{`
`}{`Fight opponents 1 & 2. After 2nd fight menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-11"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Accelerating Last Stand > First Strike`}</li>
            <li parentName="ul">{`+Last Stand Critical > Augmented First Strike`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Fight opponents 3 & 4. After 4th fight menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-12"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Empowering Last Stand > Accelerating Last Stand`}</li>
            <li parentName="ul">{`+Solo Fighter > Inverted Affinity`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-1"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`-Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Fight 3rd opponent 2 more times. Then menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-13"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Accelerating Last Stand > Last Stand Critical`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-2"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+(UR) Last Stand Critical`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Fight 3rd opponent 1 more time.`}<br parentName="p"></br>{`
`}{`Load S0, then menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-14"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+SOS Power > Empowering Last Stand`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Load `}<strong parentName="p">{`S6 - Outside Hidden Gestral Arena Save`}</strong>{`.`}</p>
    <h3 {...{
      "id": "continent-6"
    }}>{`Continent`}</h3>
    <p>{`Picto save, then quickly load `}<strong parentName="p">{`S4 - OL Skip Save`}</strong>{`. As save is loading, quickly open & close menu, and `}<strong parentName="p">{`mount Esquie`}</strong>{`.`}</p>
    <p>{`Ride Esquie past the trees and off into the water. There's a part of the ground that protrudes out like a dock.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Visages`}</strong>{`. Before entering, load `}<strong parentName="p">{`S2 - Hidden Gestral Arena`}</strong>{` save and then enter `}<strong parentName="p">{`Visages`}</strong>{`.`}</p>
    <h3 {...{
      "id": "visages"
    }}>{`Visages`}</h3>
    <Menu timing="During cutscene at start" mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <p>{`+Lune`}</p>
      <h5 {...{
        "id": "pictos-15"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Augmented First Strike > Energising Start I`}</li>
            <li parentName="ul">{`+Accelerating Last Stand > Augmented First Strike (Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-3"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Talk to Merchant`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If you got 1 Resplendant and 1 Polished from Arena, buy 1 Polished and 2 Resplendant. You can then upgrade Coralim to LV13. You will need to replace the Lumina with pickups in Lumiere in Act 3.`}</p>
      </blockquote>
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Polished (6)`}</li>
        <li parentName="ul">{`1 Resplendant`}</li>
        <li parentName="ul">{`2 Color of Lumina (4)`}</li>
      </ul>
    </Menu>
    <Menu timing="Flag before Visages" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-4"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +33 Might (41)`}</li>
        <li parentName="ul">{`Verso: +27 Might (60)`}</li>
        <li parentName="ul">{`Maelle: +33 Might (51)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-4"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Recoat, +Storm Caller`}</li>
        <li parentName="ul">{`Maelle: +Rain of Fire`}</li>
      </ul>
    </Menu>
    <Menu timing="Entering Mask Keeper fight" mdxType="Menu">
      <h5 {...{
        "id": "pictos-16"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+(S2) Empowering Last Stand`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-4"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`You can cut shots if damage is good. In absolute worst case (Anxiety Mask 1st, very little / no crit damage, might be short on damage)`}</p>
      </blockquote>
      <h4 {...{
        "id": "visages-1"
      }}>{`Visages`}</h4>
      <h5 {...{
        "id": "turn-0-1"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Offensive Switch`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <p>{`Counter both moves.`}</p>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Storm Caller`}</li>
        <li parentName="ul">{`Verso: Shoot till 4AP, Berserk Slash`}</li>
        <li parentName="ul">{`Maelle: Shoot 4 times, Rain of Fire`}</li>
      </ul>
      <p>{`Counter, should die to Storm Caller.`}</p>
    </Battle>
    <h3 {...{
      "id": "camp-4"
    }}>{`Camp`}</h3>
    <p>{`Talk to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-1"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Coralim +5 (12)`}</li>
      </ul>
    </Menu>
 
    <Menu timing="Any time before Feetress" mdxType="Menu">
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <p>{`-Lune,-Maelle`}</p>
    </Menu>
    <h3 {...{
      "id": "monolith"
    }}>{`Monolith`}</h3>
    <Menu timing="Cutscene before Feetress" mdxType="Menu">
      <h5 {...{
        "id": "pictos-17"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`-(S2) Accelerating Last Stand`}</li>
            <li parentName="ul">{`-(S3) Critical Burn > Immaculate`}</li>
          </ul></li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`You can use mouse to finish Lumina while Feetress fight is starting.`}<br parentName="p"></br>{`
`}{`Verso lumina is optional, saves 1s on Feetress.`}</p>
      </blockquote>
      <h5 {...{
        "id": "lumina-5"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Accelerating Last Stand`}</li>
            <li parentName="ul">{`-Augmented First Strike`}</li>
            <li parentName="ul">{`+Empowering Last Stand`}</li>
            <li parentName="ul">{`+Last Stand Critical`}</li>
            <li parentName="ul">{`+Solo Fighter`}</li>
          </ul></li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`You can do formation after the battle before the loading screen.`}</p>
      </blockquote>
      <h5 {...{
        "id": "formation-4"
      }}>{`Formation`}</h5>
      <p>{`+Lune,-Verso,+Maelle`}</p>
    </Menu>
    <p>{`Feetress: Skip`}</p>
    <p>{`Pick up `}<strong parentName="p">{`Weakness Gain`}</strong>{`.`}</p>
    <Menu timing="Jump at end of Tainted Forgotten Battlefield" mdxType="Menu">
      <h5 {...{
        "id": "formation-5"
      }}>{`Formation`}</h5>
      <p>{`-Maelle`}</p>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Recoat`}</strong>{` if 0 owned.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You can Chroma Elixer to make a safety save before Renoir`}</p>
    </blockquote>
    <Menu timing="Cutscene entering Renoir battle" mdxType="Menu">
      <h5 {...{
        "id": "pictos-18"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+(S2) Weakness Gain`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I (LRU from slot 2)`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "renoir-2"
      }}>{`Renoir 2`}</h4>
      <blockquote>
        <p parentName="blockquote">{`You need 28315 extra damage. Headshots do 621 damage.`}<br parentName="p"></br>{`
`}{`With Coralim LV13, need 23038, headshots do 678 damage.`}</p>
      </blockquote>
      <p>{`Counter everything until good on damage & AP.`}<br parentName="p"></br>{`
`}{`Turn 2 & 3 are interchangable based on turn 2 AP.`}</p>
      <ol>
        <li parentName="ol">{`Ice Lance`}</li>
        <li parentName="ol">{`Lightning Dance / Tint Self / Attack`}</li>
        <li parentName="ol">{`Tint Self / Attack / Lightning Dance`}</li>
        <li parentName="ol">{`Lightning Dance (if short on damage and/or AP, Attack and Lightning Dance next turn)`}</li>
      </ol>
    </Battle>
    <Menu timing="Jumping into portal for Monolith Peak" mdxType="Menu">
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <p>{`Equip Barrier Breaker (Go to inventory and mash confirm)`}</p>
    </Menu>
    <Menu timing="Flag before Paintress" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-5"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +21 Agility (31)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-5"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Recoat, +Elemental Trick, +Lightning Dance`}</li>
        <li parentName="ul">{`Lune: Lightning Dance (Left-Top)`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Paintress battle" mdxType="Menu">
      <h5 {...{
        "id": "skills-4"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`-Offensive Switch`}</li>
            <li parentName="ul">{`-Percee`}</li>
            <li parentName="ul">{`-Swift Stride`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "paintress"
      }}>{`Paintress`}</h4>
      <blockquote>
        <p parentName="blockquote">{`With Coralim LV13,`}<br parentName="p"></br>{`
`}{`Phase 1 is the same,`}<br parentName="p"></br>{`
`}{`Phase 2, skip counter on both brush attacks, rips reality, and unleashes. Still need to parry for AP though, just don't need counter.`}<br parentName="p"></br>{`
`}{`Phase 3: Tint > Elemental Trick > Mayhem`}</p>
      </blockquote>
      <h5 {...{
        "id": "phase-1"
      }}>{`Phase 1`}</h5>
      <ul>
        <li parentName="ul"><em parentName="li">{`Parry everything for AP but don't counter`}</em></li>
        <li parentName="ul">{`(Elemental Trick > Lightning Dance) x2`}</li>
      </ul>
      <h5 {...{
        "id": "phase-2-1"
      }}>{`Phase 2`}</h5>
      <ul>
        <li parentName="ul"><em parentName="li">{`Counter Everything`}</em></li>
        <li parentName="ul">{`Elemental Trick`}</li>
        <li parentName="ul">{`Lightning Dance`}</li>
        <li parentName="ul">{`Shoot 4 shields, Elemental Trick`}</li>
        <li parentName="ul">{`Lightning Dance`}</li>
      </ul>
      <h5 {...{
        "id": "phase-3"
      }}>{`Phase 3`}</h5>
      <ul>
        <li parentName="ul">{`Energy Tint`}</li>
        <li parentName="ul">{`Thunderfall`}</li>
        <li parentName="ul">{`Mayhem`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "act-3"
    }}>{`Act 3`}</h3>
    <Menu timing="Cutscene talking to Renoir" mdxType="Menu">
      <h5 {...{
        "id": "pictos-19"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+(S3) Painted Power`}</li>
            <li parentName="ul">{`+Immaculate > Empowering Last Stand`}</li>
          </ul></li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`To equip Immaculate, select Immaculate and hover over Empowering Last Stand.`}<br parentName="p"></br>{`
`}{`After you skip the cutscene, mash confirm.`}</p>
      </blockquote>
    </Menu>
    <h3 {...{
      "id": "camp-5"
    }}>{`Camp`}</h3>
    <p>{`Load save at `}<strong parentName="p">{`Hidden Gestral Arena`}</strong>{`. It will be the most recent save with a low play time.`}<br parentName="p"></br>{`
`}{`Load S0 and enter `}<strong parentName="p">{`Hidden Gestral Arena`}</strong>{` while it's loading.`}</p>
    <h3 {...{
      "id": "hidden-gestral-arena-1"
    }}>{`Hidden Gestral Arena`}</h3>
    <p>{`Exit Hidden Gestral Arena.`}</p>
    <Menu timing="While jumping out of Hidden Gestral Arena. Needs to be done before Abberation." mdxType="Menu">
      <h5 {...{
        "id": "formation-6"
      }}>{`Formation`}</h5>
      <p>{`-Verso, -+Maelle`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-7"
    }}>{`Continent`}</h3>
    <p>{`Fly to Lumiere`}</p>
    <h3 {...{
      "id": "lumiere"
    }}>{`Lumiere`}</h3>
    <Menu timing="Flag at start" mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-6"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Stendhal, +Mezzo-Forte, +Last Chance`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h5 {...{
        "id": "abberation"
      }}>{`Abberation`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Energy Tint Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Battle>
    <Menu timing="On jump" mdxType="Menu">
      <h5 {...{
        "id": "pictos-20"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+(Triangle) Shortcut > Energising Start I`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Talk to Merchant`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`5 Resplendant`}</li>
        <li parentName="ul">{`3 Colour of Lumina (7)`}</li>
      </ul>
    </Menu>
    <p>{`Flee from Creation.`}</p>
    <Menu timing="Flag before Renoir 3" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-6"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +24 Agility (24)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons-2"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Barrier Breaker +3 (18)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-expedition-resources"
      }}>{`Upgrade Expedition Resources`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +7 (32)`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene before Renoir 3" mdxType="Menu">
      <h5 {...{
        "id": "formation-7"
      }}>{`Formation`}</h5>
      <p>{`-Lune`}</p>
      <h5 {...{
        "id": "lumina-6"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Accelerating Last Stand`}</li>
            <li parentName="ul">{`+Augmented First Strike`}</li>
            <li parentName="ul">{`+Empowering Last Stand`}</li>
            <li parentName="ul">{`+Last Stand Critical`}</li>
            <li parentName="ul">{`+Solo Fighter`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "renoir-3"
      }}>{`Renoir 3`}</h4>
      <h5 {...{
        "id": "phase-1-1"
      }}>{`Phase 1`}</h5>
      <p>{`Don't counter anything to preserve Augmented First Strike`}</p>
      <ul>
        <li parentName="ul">{`Energy Tint Maelle`}</li>
        <li parentName="ul">{`Stendhal`}</li>
      </ul>
      <h5 {...{
        "id": "phase-2-2"
      }}>{`Phase 2`}</h5>
      <p>{`Dodge everything`}</p>
      <ul>
        <li parentName="ul">{`Last Chance > Stendhal`}</li>
      </ul>
    </Battle>
    <p><strong parentName="p">{`Chroma Elixer`}</strong>{` before fighting Verso.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "verso"
      }}>{`Verso`}</h4>
      <ul>
        <li parentName="ul">{`Last Chance > Rain of Fire`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "links"
    }}>{`Links`}</h3>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/MhUR2Jv_vvI?si=T2P1dlXM02oTzGGw"
      }}>{`Cardinal's Windmill`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=a5EVfG5KKVs&list=PLEdCsgJaGX6KNlVMMzIbkyy4Exq7R2voN"
      }}>{`Cardinal Playlist`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=ilRC2Te-Q04"
      }}>{`Cardinal Old Lumiere Skip`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://youtu.be/wpj4CUCesO0"
      }}>{`Password Skip`}</a></p>
    <h3 {...{
      "id": "notes"
    }}>{`Notes`}</h3>
    <p>{`Gestral Arena`}<br parentName="p"></br>{`
`}{`1. 2228XP $392 Last Stand Critical`}<br parentName="p"></br>{`
`}{`2. 8506XP $686 Accelerating Last Stand`}<br parentName="p"></br>{`
`}{`3. 19190XP $1022 Protecting Last Stand`}<br parentName="p"></br>{`
`}{`4. 31248XP $1392 Empowering Last Stand`}</p>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h5 {...{
      "id": "41626"
    }}>{`4/16/26`}</h5>
    <ul>
      <li parentName="ul">{`Update OL Skip to use Camp. Camp dismount save 2.5s LRT`}</li>
      <li parentName="ul">{`Correct Act 3 Maelle Picto, Accelerating Last Stand was supposed to be Empowering Last Stand`}</li>
    </ul>
    <h5 {...{
      "id": "32626"
    }}>{`3/26/26`}</h5>
    <ul>
      <li parentName="ul">{`Add note to pick up house Chroma if Windmilling.`}</li>
      <li parentName="ul">{`Add missing Energy Tint pickup to notes.`}</li>
    </ul>
    <h5 {...{
      "id": "32526"
    }}>{`3/25/26`}</h5>
    <ul>
      <li parentName="ul">{`Monolith Skill Recoat after Renoir 2`}</li>
      <li parentName="ul">{`Renoir 2 Ice Lance strat`}</li>
      <li parentName="ul">{`Lune gets 2 might, 4 agi at Flying Waters`}</li>
      <li parentName="ul">{`Visages picto menus changed, Lune gets Accelerating and Maelle gets Empowering`}</li>
      <li parentName="ul">{`Take off Verso First Strike for Feetress`}</li>
      <li parentName="ul">{`Remove Upgrade Attributes in Tainted Lumiere`}</li>
      <li parentName="ul">{`Equip Barrier Breaker on transition to top of monolith.`}</li>
      <li parentName="ul">{`Equip Immaculate to Maelle at start of Act 3 cutscene`}</li>
    </ul>
    <h5 {...{
      "id": "32226"
    }}>{`3/22/26`}</h5>
    <ul>
      <li parentName="ul">{`Add notes for Coralim LV13`}</li>
    </ul>
    <h5 {...{
      "id": "32026"
    }}>{`3/20/26`}</h5>
    <ul>
      <li parentName="ul">{`Francois notes simplified, added backup for no crit`}</li>
      <li parentName="ul">{`Chroma Elixer for MS Skip, menu for OL Skip`}</li>
      <li parentName="ul">{`Changed note format for Old Lumiere skip, added save positions`}</li>
      <li parentName="ul">{`Different saves used for OL Skip, use Hidden Gestral Arena save for Esquie mounts.`}</li>
      <li parentName="ul">{`Moved 1 picto equip from Arena to Visages.`}</li>
      <li parentName="ul">{`More menuing in 1st cutscene menu in Visages, Lune now gets Augmented First Strike for Mask Keeper`}</li>
      <li parentName="ul">{`Visages flag: Lune gets all Might here now, and Blitz is skipped.`}</li>
      <li parentName="ul">{`Can add Lune to Formation on Feetress end transition`}</li>
      <li parentName="ul">{`Equip Maelle with Barrier Breaker in Monolith`}</li>
      <li parentName="ul">{`Lune gets 4 Agility before Renoir 2 (moved from Visages)`}</li>
      <li parentName="ul">{`Added note on how much counter damage Renoir 2 needs`}</li>
      <li parentName="ul">{`Remove Maelle skills on Paintress Transition`}</li>
      <li parentName="ul">{`New faster Paintress Phase 3 using Mayhem`}</li>
      <li parentName="ul">{`Act 3 Formation done while exiting Hidden Gestral Arena`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      